import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-noauth-layout',
  templateUrl: './noauth-layout.component.html',
  styleUrls: ['./noauth-layout.component.css']
})
export class NoauthLayoutComponent {

}
